<div class="form-metrics-widget" *ngIf="item">
  <h6 class="widget-title">{{ item.label }}</h6>
  <p class="widget-meta text-muted mb-2">
    {{ totalComments }} comentário(s)
    <span *ngIf="highlightedEmployeeId" class="text-primary"> · respondente selecionado</span>
  </p>

  <ng-container *ngIf="preview.length > 0; else empty">
    <div
      class="comment-preview"
      [class.comment-preview--highlighted]="comment.isHighlighted"
      *ngFor="let comment of preview">
      <span *ngIf="comment.isHighlighted" class="comment-badge">Respondente selecionado</span>
      <p class="mb-0"><em>"{{ comment.text }}"</em></p>
    </div>

    <button
      #viewAllBtn
      type="button"
      class="btn btn-sm btn-outline-primary mt-2"
      *ngIf="!highlightedEmployeeId"
      (click)="onViewAll(); viewAllBtn.blur()">
      Ver todos
    </button>
  </ng-container>

  <ng-template #empty>
    <p class="text-muted text-center py-3 mb-0">
      {{
        highlightedEmployeeId
          ? 'Este respondente não deixou comentário nesta pergunta.'
          : 'Sem respostas no período selecionado.'
      }}
    </p>
  </ng-template>
</div>
